import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchCompany } from "../actions";
import CompanyContainer from "../containers/company_container";
import InvestorContainer from "../containers/investor_container";

class App extends Component {
  componentDidMount() {
    const { company_url_path_name, fetchCompany } = this.props;
    fetchCompany(company_url_path_name);
  }

  render () {
    const { company } = this.props;
    return company.hasOwnProperty("name") && (
      <main role='main'>
        <CompanyContainer />
        <div className='container border-top-stripe-sm'>
          <InvestorContainer />
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  company: Object.assign(state.company, ownProps)
});

const mapDispatchToProps = dispatch => ({
  fetchCompany: (name) => dispatch(fetchCompany(name))
});

App.propTypes = {
  company_url_path_name: PropTypes.string.isRequired,
  fetchCompany: PropTypes.func.isRequired,
  company: PropTypes.shape({
    name: PropTypes.string
  }).isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
